export default __webpack_public_path__ + "static/media/photo-1542744094-3a31f272c490.be26aaf7.jpg";